import SkyClickPlayer from './SkyClickPlayer';
import ComponentWrapper from "../wrappers/ComponentWrapper";
import Dom from "../../utils/custom/Dom"
import EventUtilWrapper from "../../utils/wrappers/Events"
import RelatedPlugin from "../../plugins/custom/RelatedPlugin";
import ButtonComponentWrapper from "../wrappers/ButtonComponentWrapper";
import DomUtilWrapper from "../../utils/wrappers/Dom";
import DateUtils from "../../utils/DateUtils";
import UrlWrapper from "../../utils/wrappers/Url";

declare global {
    interface SkyClickRelatedViewerComponentOptions{
        relatedPlugin: RelatedPlugin,
        relatedItems: Array<any>,
        closeHandler: Function,
    }
}


export default class RelatedViewer extends ComponentWrapper{

    // Define default name of component. It used for component instantiation by string (player.addChild('componentName')).
    // So we have the ability to load the component instance by name (player.getChild('componentName').
    public name_ = 'RelatedViewer';

    protected cancelButton:HTMLElement;
    protected countDownElement:HTMLElement;
    protected itemContainer:HTMLElement;

    protected countdownProcessReference:any;

    constructor(skyClickPlayer:SkyClickPlayer,options:SkyClickRelatedViewerComponentOptions){
        super(skyClickPlayer,options);

        // hide viewer at startup
        this.hide()
    }

    public buildCSSClass(){
        // Add our className to the returned className
        return 'vjs-related-viewer ' + super.buildCSSClass();
    }

    createEl() {
        let props = {
            className: this.buildCSSClass()
        };

        // create viewer div
        const el = super.createEl('div', props);

        // add default html to viewer
        el.innerHTML = `
            <div class="vjs-related-header">
                ${this.getPluginInstance().headingTitle || ''}
                <a class="vjs-icon-cancel"></a>
            </div>
            <div class="vjs-related-grid">
                <div class="vjs-related-grid-center-content"></div>
            </div>
        `;

        // extract dom references
        this.cancelButton = Dom.$('.vjs-icon-cancel', el);

        this.itemContainer = Dom.$('.vjs-related-grid-center-content', el);

        // add listeners
        EventUtilWrapper.on(this.cancelButton, 'click', this.getCloseHandler());

        // render items
        this.renderItems(this.itemContainer);

        return el;
    }

    protected getPluginOptions():SkyClickRelatedPluginOptions{
        return this.options().relatedPlugin.options;
    }

    protected getRelatedItems(){
        return this.options().relatedItems;
    }


    protected getCloseHandler(){
        return this.options().closeHandler;
    }

    protected getPluginInstance():RelatedPlugin{
        return this.options().relatedPlugin;
    }

    protected renderItems(gridElement:HTMLElement){
        const relatedItems = this.getRelatedItems();
        relatedItems.forEach((item:any, index:number) => {

            // calculate size of items in grid
            let calculatedGrid = '';
            switch(relatedItems.length){
                case 1:
                    calculatedGrid = '1-1';
                    break;
                case 2:
                    calculatedGrid = '2-1';
                    break;
                case 3:
                    if(index != relatedItems.length-1){
                        calculatedGrid = '2-2';
                    }else{
                        calculatedGrid = '1-2';
                    }
                    break;
                case 4:
                    calculatedGrid = '2-2';
                    break;
            }

            // render item element
            let relatedItemAttributes:any = {
                'class': `vjs-related-item vjs-related-item-${item.type} vjs-related-size-${calculatedGrid}`,
                'id': `'related-item-id-${index}`
            };
            // Add title tooltip, when item has title property

            // Title as tooltip
            if(this.getPluginOptions().itemOptions.showTitleTooltip && item.title){
                relatedItemAttributes.title = item.title;
            }
            let domItem = Dom.createEl('div',undefined, relatedItemAttributes);

            Dom.appendContent(gridElement, domItem);

            // render type specific elements
            switch(item.type){
                case 'video':

                    // Thumbnail element
                    let thumbItem = Dom.createEl('div',undefined,{
                        'class': `vjs-related-thumbnail`,
                        'style': `background-image: url('${item.image}')`
                    });
                    Dom.appendContent(domItem, thumbItem);

                    // Optional: Duration element
                    if(item.duration){
                        let durationItem = Dom.createEl('div',undefined,{
                            'class': `vjs-related-video-duration-container`
                        });
                        durationItem.innerHTML = `<div class="vjs-related-video-duration">${DateUtils.secondsToHHMMSS(item.duration)}</div>`;
                        Dom.appendContent(domItem, durationItem);
                    }


                    // *** Title element
                    let displayTitleModeClass = '';
                    switch(<SkyClickRelatedItemTitleDisplayMode>this.getPluginOptions().itemOptions.displayTitleMode){
                        case 'visible':
                            displayTitleModeClass = 'vjs-related-title-mode-visible';
                            break;
                        case 'hover':
                            displayTitleModeClass = 'vjs-related-title-mode-hover';
                            break;
                        case 'hidden':
                        default:
                            displayTitleModeClass = 'vjs-related-title-mode-hidden';
                            break;
                    }
                    // Thumbnail cover element
                    let thumbCoverItem = Dom.createEl('div',undefined,{
                        'class': `vjs-related-thumbnail-cover ` + displayTitleModeClass
                    });
                    Dom.appendContent(domItem, thumbCoverItem);

                    let titleItem = Dom.createEl('div',undefined,{
                        'class': `vjs-related-thumbnail-title ` + displayTitleModeClass
                    });
                    Dom.appendContent(titleItem, item.title);
                    Dom.appendContent(domItem, titleItem);

                    // Autoplay Element
                    if(index == 0){
                        const countdownItem = this.countDownElement = Dom.createEl('div',undefined,{
                            'class': 'vjs-related-autoplay-countdown vjs-hidden' // the countdown element is hidden as default
                        });
                        // countdownItem.innerHTML = `
                        //     <svg width="30%" height="100%" xmlns="http://www.w3.org/2000/svg">
                        //          <g>
                        //               <title>Layer 1</title>
                        //               <circle transform="rotate(-90)" id="circle" class="circle_animation" r="30%" cy="50%" cx="50%" stroke-width="3" stroke="#6fdb6f" fill="none" style="stroke-dashoffset: 0px;"></circle>
                        //          </g>
                        //     </svg>
                        // `;

                        // Countdown circle
                        countdownItem.innerHTML = `
                            <svg viewBox="0 0 100 100" class="vjs-related-autoplay-circle-svg">
                                <!-- Full circle, fine line -->
                                <!--<path class="vjs-related-autoplay-static-circle" d="M 50,50 m 0,-47 a 47,47 0 1 1 0,94 a 47,47 0 1 1 0,-94" stroke="#eee" stroke-width="1" fill="#000000"></path>-->
                                <!-- Progress line -->
                                <path class="vjs-related-autoplay-progress-circle" d="M 50,50 m 0,-47 a 47,47 0 1 1 0,94 a 47,47 0 1 1 0,-94" stroke="#FFFFFF" stroke-width="4" fill="#000000" style="stroke-dasharray: 295.416, 295.416; stroke-dashoffset: 295.416;"></path>
                                <!--<polygon class="ytp-svg-autoplay-triangle" fill="#fff" points="32,27 72,49 32,71"></polygon>-->
                                <polygon class="ytp-svg-autoplay-triangle" fill="#fff" points="32.382 24.859 75.916 48.804 32.382 72.747"/>
                            </svg>
                        `;
                        Dom.appendContent(domItem, countdownItem);
                        // Play icon
                        // const countdownPlayItem = Dom.createEl('div',undefined,{
                        //     'class': 'vjs-icon-play'
                        // });
                        // Dom.appendContent(countdownItem, countdownPlayItem);

                        /** ToDo
                         * - Implement all font-changes relative with percentage% (change font size, only on player main div on full-screenmode, like youtube did it)
                         * - Take for the click items "A" or "Button" element instead of raw div.
                         */

                        // Cancel Button
                        const cancelButtonWrapper = Dom.createEl('div',undefined,{
                            'class': 'vjs-related-autoplay-cancel-container'
                        });
                        cancelButtonWrapper.innerHTML = `
                            <button class="vjs-related-autoplay-cancel-button">
                                <!--<span class="vjs-icon-cancel">&nbsp;</span>-->
                                <span class="vjs-related-autoplay-cancel-button-text">STOP</span>
                            </button>`;
                        Dom.appendContent(countdownItem, cancelButtonWrapper);
                        let cancelButton = Dom.$('.vjs-related-autoplay-cancel-button', cancelButtonWrapper);
                        EventUtilWrapper.on(cancelButton,'click',this.cancelCountdown.bind(this));
                    }

                    break;

                case 'html':
                    let contentItem = Dom.createEl('div',undefined,{
                        'class': 'vjs-related-item-html-content'
                    });
                    contentItem.innerHTML = item.html;

                    Dom.appendContent(domItem, contentItem);
                    break;
            }

            // add link
            if(item.link){
                let isIFrameMode = this.getPluginInstance().skyClickPlayer.iFrameMode;
                const clickArea = Dom.createEl('a',undefined,{
                    'class': 'vjs-related-click-area',
                    'href': UrlWrapper.getAbsoluteURL(item.link), // Need to open relative links on same host, when player is in iFrame an link target is "_parent"
                    'target': isIFrameMode ? '_blank' : '' // Open links in tab, when player is in iFrame
                });
                Dom.appendContent(domItem, clickArea);
            }

        });

    }

    public startCountDown(completeCallback:Function){
        // reset visiblity of countdown
        Dom.removeElClass(this.countDownElement, 'vjs-hidden');

        // calculate countdown time in milliseconds
        const countDownDuration = this.getPluginInstance().autoPlayCountDownDuration * 1000;

        // store start time
        const startTime = (new Date()).getTime();

        // get svg progress circle
        const svgProgressCircle = Dom.$$('.vjs-related-autoplay-progress-circle',this.countDownElement)[0];

        // load initial offset of border around the circle
        // (strokeDasharray and strokeDashoffset must be same, before countdown start, to have a 0% circled border around the circle)
        let initialOffset = parseFloat(svgProgressCircle.style.strokeDasharray.split(',')[0].trim());

        let processCountdown = () => {
            const currentTime = (new Date()).getTime();

            // calculated progress percentage
            const percentage = (currentTime-startTime) / countDownDuration;

            /**
             * Animated svg: draw border around circle
             *
             * Animation explanation:
             * When strokeDashoffset and strokeDasharray array have the same value, then you see now border around the circle (%0 visible of the circle).
             * When the strokeDashoffset is 0, then you see a fully circled border around the filled circle (100% visible of the circle).
             *
             * Calculation example
             * strokeDashoffset = initialOffset * 1 => fully circled border (100%)
             * strokeDashoffset = initialOffset * 0.25 => a quarter circled border (25%)
             */
            svgProgressCircle.style.strokeDashoffset = ''+initialOffset*(1-percentage);

            if (percentage >= 1 ) {
                // 100% reached
                // make border fully circled around the filled circle
                svgProgressCircle.style.strokeDashoffset = '0';
                // call custom callback, because countdown expired
                completeCallback();
            }else{
                // 100% NOT reached
                // request next animation frame
                this.countdownProcessReference = requestAnimationFrame(processCountdown);
            }

        };

        // start countdown
        this.countdownProcessReference = requestAnimationFrame(processCountdown);
    }

    public cancelCountdown(){
        if(this.countdownProcessReference){
            // cancel countdown interval
            cancelAnimationFrame(this.countdownProcessReference);

            // reset circle progress to 0 percentage
            let circle = Dom.$$('.vjs-related-autoplay-progress-circle',this.countDownElement)[0];
            circle.style.strokeDashoffset = circle.style.strokeDasharray.split(',')[0];

            // hide countdown element
            Dom.addElClass(this.countDownElement, 'vjs-hidden');
        }
    }


    /**
     * Also cancel countdown when hide viewer (close with x button)
     */
    public hide():VideoJSComponent{
        let component = super.hide();
        this.cancelCountdown();
        return component;
    }



}


// WEBPACK FOOTER //
// ./src/app/components/custom/RelatedViewer.ts